import { DateFormat, formatLocalDate } from '@/common/utils/dateFormats';

/**
 * A run's moment, short enough to sit inside a sentence: "Aug 4 5:46 PM".
 *
 * Composed from the shared presets rather than written as a format string, the same way
 * `formatLocalDateWithTime` composes one — a run list where two runs from the same day differ only
 * by time needs the time, and the classic view's full "August 4, 2026 5:46 PM" is too long to read
 * as a clause.
 */
export const formatRunMoment = (generatedAt: string): string =>
  formatLocalDate(generatedAt, `${DateFormat.MONTH_SHORT_DAY_SHORT} ${DateFormat.ISO_SHORT_TIME}`);
